module.exports = __webpack_public_path__ + "6fa8f8b82385fad558e097c95b79e143.pdf";